(() => {
  const MOBILE_MQ = '(max-width: 767px)';
  const SLIDER_SELECTOR = '.uchi-intention__grid.is-slider, .uchi-featured__grid.is-slider, .uchi-howto__grid.is-slider, .uchi-testimonials__track.is-slider';
  const sliderStates = new WeakMap();

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  function slidesOf(track) {
    return Array.from(track.children).filter((el) => el.nodeType === 1 && !el.classList.contains('uchi-dots'));
  }

  function closestIndex(track, slides) {
    const viewCenter = track.scrollLeft + track.clientWidth / 2;
    let closest = 0;
    let min = Infinity;
    slides.forEach((slide, index) => {
      const center = slide.offsetLeft + slide.offsetWidth / 2;
      const distance = Math.abs(center - viewCenter);
      if (distance < min) {
        min = distance;
        closest = index;
      }
    });
    return closest;
  }

  function setActiveDot(dots, index) {
    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function targetLeft(track, slide) {
    const padding = parseFloat(getComputedStyle(track).paddingLeft || '0');
    return Math.max(0, slide.offsetLeft - padding);
  }

  function animateScroll(track, toLeft, duration) {
    const start = track.scrollLeft;
    const change = toLeft - start;
    if (Math.abs(change) < 1) return;

    if (prefersReducedMotion()) {
      track.scrollLeft = toLeft;
      return;
    }

    const startTime = performance.now();
    track.style.scrollSnapType = 'none';

    const step = (now) => {
      const progress = Math.min(1, (now - startTime) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      track.scrollLeft = start + change * eased;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        track.scrollLeft = toLeft;
        track.style.scrollSnapType = '';
      }
    };

    requestAnimationFrame(step);
  }

  function destroySlider(track) {
    const state = sliderStates.get(track);
    if (!state) return;
    track.removeEventListener('scroll', state.onScroll);
    if (state.dotsNav) state.dotsNav.remove();
    sliderStates.delete(track);
    delete track.dataset.uchiSliderInit;
  }

  function initSlider(track) {
    if (!track || track.dataset.uchiSliderInit === 'true') return;

    const slides = slidesOf(track);
    if (slides.length < 2) return;

    const nav = document.createElement('div');
    nav.className = 'uchi-dots';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Navegación del carrusel');

    const dots = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'uchi-dot';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', `Ir al elemento ${index + 1}`);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        animateScroll(track, targetLeft(track, slide), 520);
      });
      nav.appendChild(button);
      return button;
    });

    track.insertAdjacentElement('afterend', nav);
    setActiveDot(dots, closestIndex(track, slides));

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActiveDot(dots, closestIndex(track, slides));
        ticking = false;
      });
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    track.dataset.uchiSliderInit = 'true';
    sliderStates.set(track, { dotsNav: nav, onScroll });
  }

  function syncSliders(root = document) {
    root.querySelectorAll(SLIDER_SELECTOR).forEach((track) => {
      if (isMobile()) initSlider(track);
      else destroySlider(track);
    });
  }

  document.addEventListener('DOMContentLoaded', () => syncSliders(document));

  document.addEventListener('shopify:section:load', (event) => {
    syncSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => syncSliders(document), 150);
  });
})();
